// MenuItemsProvider.js
import generalPages from './general-pages';
import getCustomerServicePage from './customer-services-pages';
import getVenueAdminPage from './venue-admin-pages';
import { useUserContext } from '../contexts/UserContext.jsx';

const MenuItemsProvider = () => {
  const { selectedVenue, selectedVenueData, user } = useUserContext();

  let tempMenuItems = [];

  if (user?.venues?.length > 0 || (user?.isSuperAdmin && selectedVenue)) {
    const venueAdminMenu = getVenueAdminPage(selectedVenue, selectedVenueData);

    if (Array.isArray(venueAdminMenu)) {
      tempMenuItems.push(...venueAdminMenu);
    } else if(venueAdminMenu) {
      tempMenuItems.push(venueAdminMenu);
    }
  }

  if (user?.isSuperAdmin) {
    const customerServiceMenu = getCustomerServicePage();

    if (Array.isArray(customerServiceMenu)) {
      tempMenuItems.push(...customerServiceMenu);
    } else if (customerServiceMenu) {
      tempMenuItems.push(customerServiceMenu);
    }
  }

  tempMenuItems.push(generalPages);

  const menuItems = {
    items: tempMenuItems
  };

  return menuItems;
};

export default MenuItemsProvider;